<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :height="250"
  />
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  ChartDataLabels
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },

    chartData: {
      labels: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July'
      ],
      datasets: [
        {
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [40, 39, 10, 40, 39, 80, 40]
        }
      ]
    }
  },
  data() {
    return {
      plugins: [ChartDataLabels, 
        { beforeInit(chart) {
            const originalFit = chart.legend.fit;

            // Override the fit function
            chart.legend.fit = function fit() {
              // Call original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              // Change the height as suggested in another answers
              this.width += 50;
            }
          }
        }],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

          datalabels: {
            align: 'end',
            anchor: 'end',
            formatter: function(value, ctx) {
              return ctx.active && value.feed_type!="42" ? value.shop_name : value.min+' RON';
            },
            backgroundColor: function(ctx) {
              return ctx.active && ctx.dataset.data[ctx.dataIndex].feed_type!="42" ? '#252525' : (ctx.dataset.data[ctx.dataIndex].stock_id=="1"?ctx.dataset.backgroundColor:'#fff'); 
            },
            borderColor: function(ctx) {
              return ctx.active && ctx.dataset.data[ctx.dataIndex].feed_type!="42" ? '#252525' : ctx.dataset.backgroundColor; 
            },
            borderRadius: 4,
            borderWidth: 1,
            color: function(ctx) {
              return ctx.active || ctx.dataset.data[ctx.dataIndex].stock_id=="1"?'#fff':ctx.dataset.backgroundColor; 
            },
            font: {
              weight: 'bold'
            },
            padding: {top: 6,right:6, bottom:3, left:6}
          },
          legend: {
            position: 'right',
            align: 'start',
            rtl: true,
            labels: {
              textAlign: 'left',
              padding: 25,
              generateLabels: function(chart) {
                return [
                  { text: 'Nou în magazine', lineWidth:3, fillStyle: 'rgba(25,135,84, 0.75)', strokeStyle: 'rgba(25,135,84,1)', datasetIndex: 0 },
                  { text: 'SH pe Din Raft', lineWidth:3, fillStyle: 'rgba(240,154,4, 0.75)', strokeStyle: 'rgba(240,154,4,1)', datasetIndex: 1 },
                  { text: 'SH pe GeekMarket', lineWidth:3, fillStyle: 'rgba(13,110,253, 0.75)', strokeStyle: 'rgba(13,110,253,1)', datasetIndex: 2 },
                  { text: 'Lipsă stoc', lineWidth:2, fillStyle: 'rgba(255,255,255, 0.75)', strokeStyle: 'rgba(25,25,25,1)', lineDash: [6,6] }
                ];
              }
            }
          },
          tooltip: {
               enabled: false
          },
        },

        elements: {
          line: {
            fill: false,
            tension: 0.4,
            backgroundColor: function(ctx) {
              return '#252525'; 
            }
          },
          point: {
            hoverRadius: 10,
            hitRadius: 10
          }
        },
        layout: {
            padding: { top: 40, right: 20, bottom:20, left:20 }
        },
        segment: {
            borderDash: function(ctx) {
              return ctx.p0.raw.stock_id == "1" ? undefined : [6,6];
            }
        }

      }
    }
  }
}
</script>
